import { useEffect, useState } from 'react'

// Components
import ManageClinicNOtherCard from '../../common/card/ManageClinicNOtherCard'
import ManageClinicNOtherGraphSection from '../../ManageClinicNOtherGraphSection'

// Constants
import { ICONS_SRC } from '../../ManageClinicNOtherRootPage'

// Redux
import { useAppSelector } from '../../../../../store/hooks'

// Util
import { selectedEvent } from '../../../../../store/events/eventsSlice'
import { getFloatPrice } from '../../../../../helpers/price'
import { getCurrency, getTotalPrices } from '../../../../../helpers/payment'
import useToasterHelper from '../../../../../helpers/ToasterHelper'

import RegistrationDyDayService from '../../../../../services/firebase-service/registration-by-day/RegistrationDyDayService'
import RegistrationFeesService from '../../../../../services/firebase-service/registration-fees/RegistrationFeesService'
import RegistrationTicketService from '../../../../../services/firebase-service/registration-tickets/RegistrationTicketService'

import { ROUTES_CONST } from '../../../../../const/routes-const'
import { MESSAGES_CONST } from '../../../../../const/messages-const'

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%\

// Types
type Props = {
  eventId: string
}

const ManageClinicNOtherFinancesTab = (props: Props) => {
  const toast = useToasterHelper()

  // Hooks and vars
  const event = useAppSelector(selectedEvent)
  const currency = getCurrency(event.Event?.currency)

  const [paidAmount, setPaidAmount] = useState<number>(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true)
        const eventId = event.Event?.id

        if (eventId) {
          const registrationsByDay = await RegistrationDyDayService.getByEventIds([eventId])
          const registrationsFees = await RegistrationFeesService.getByEventId(eventId)
          const registrationsTickets = await RegistrationTicketService.getByEventId(eventId)

          const { paidTotal } = getTotalPrices({
            registrationsEntries: registrationsByDay,
            registrationsFees: registrationsFees,
            registrationsTickets: registrationsTickets,
            isChargeSalesTax: event?.EventPaymentSettings?.chargeSalesTax ?? false,
          })

          setPaidAmount(paidTotal / 100)
        }
      } catch (error) {
        console.error('error: ', error)
        toast.error({
          message: MESSAGES_CONST.SOMETHING_WENT_WRONG,
        })
      } finally {
        setLoading(false)
      }
    }
    getData().then()
  }, [event, toast])

  return (
    <>
      <ManageClinicNOtherCard
        title={'Exhibitor revenue >'}
        category="finance"
        loading={loading}
        url={`${ROUTES_CONST.MANAGE.REVENUE.URL}/registration/${props.eventId}`}
        icon={ICONS_SRC.EXHIBITOR}
        value1={getFloatPrice(`${currency}${paidAmount}`)}
        className={`w-full md:w-1/4`}
      />
      <ManageClinicNOtherCard
        disabled={false}
        title={'Spectator revenue >'}
        url={`${ROUTES_CONST.MANAGE.REVENUE.URL}/spectator/${props.eventId}`}
        category="finance"
        icon={ICONS_SRC.SPECTATOR}
        value1={getFloatPrice(`${currency}${event.Event?.currentTicketRevenue}`)}
        className={`w-full md:w-1/4`}
      />

      <ManageClinicNOtherCard
        disabled={true}
        title={'Vendor revenue >'}
        icon={ICONS_SRC.VENDOR}
        category="finance"
        url={`${ROUTES_CONST.MANAGE.REVENUE.URL}/vendors/${props.eventId}`}
        value1={getFloatPrice(`${currency}${0}`)}
        className={`w-full md:w-1/4`}
      />
      <ManageClinicNOtherCard
        disabled={true}
        title={'Sponsor revenue >'}
        category="finance"
        url={`${ROUTES_CONST.MANAGE.REVENUE.URL}/sponsors/${props.eventId}`}
        icon={ICONS_SRC.SPONSOR}
        value1={getFloatPrice(`${currency}${0}`)}
        className={`w-full md:w-1/4`}
      />

      <ManageClinicNOtherGraphSection />
    </>
  )
}

export default ManageClinicNOtherFinancesTab
